export default "__VITE_ASSET__DuWR6wfG__"